export default __webpack_public_path__ + "static/media/bumblebee.872c60a6.jpeg";